import React, { useRef } from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Grid } from '@abyss/web/ui/Grid';
import { Button } from '@abyss/web/ui/Button';
import { V2FormProvider } from '@abyss/web/ui/FormProvider';
import { ImpersonateController } from './Impersonation.Controller';
import { V2SelectInput } from '@abyss/web/ui/SelectInput';
import { Layout } from '@abyss/web/ui/Layout';

export const Impersonation = () => {
  const pageTop = useRef<HTMLDivElement>(null);
  const { form, pageData, Action, IsImpersonating } = ImpersonateController();

  return (
    <div ref={pageTop}>
      <V2FormProvider state={form} onSubmit={Action.Impersonate}>
        <Box
          color="$primary2"
          css={{ 'abyss-box-root': { minHeight: '350px' } }}
        >
          <Grid>
            <Grid.Col span={{ sm: 12, md: 6, lg: 6 }}>
              <V2SelectInput
                label="Roles"
                placeholder="--No Entry--"
                model="id"
                isSearchable={true}
                options={pageData.roles}
                isDisabled={IsImpersonating}
                data-testid="input-impersonate-roles"
                isClearable
              />
            </Grid.Col>
            <Grid.Col span={{ sm: 12, md: 6, lg: 6 }}></Grid.Col>
            <Grid.Col span={{ sm: 12, md: 6, lg: 6 }}>
              <Layout.Stack grow>
                <Layout.Group space={20}>
                  <Button
                    disabled={IsImpersonating}
                    onClick={Action.Impersonate}
                  >
                    Impersonate
                  </Button>
                  <Button
                    disabled={!IsImpersonating}
                    onClick={Action.RemoveImpersonation}
                  >
                    Switch back
                  </Button>
                </Layout.Group>
              </Layout.Stack>
            </Grid.Col>
          </Grid>
        </Box>
      </V2FormProvider>
    </div>
  );
};
